import { useState } from "react";
import { useTranslation } from "react-i18next";

const CommentForm = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;

    setSending(true);
    await onSubmit(text);
    setText("");
    setSending(false);
    setShowSnackbar(true);

    playBeep();

    if (navigator.vibrate) {
      navigator.vibrate(100);
    }

    setTimeout(() => {
      setShowSnackbar(false);
    }, 2000);
  };

  const playBeep = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = 600;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.15);
      osc.stop(ctx.currentTime + 0.15);
    } catch (e) {
      console.warn("Beep no soportado en este navegador");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={styles.form} aria-label={t("comment_form.aria_label")}>
        <button type="submit" style={styles.button} disabled={!text.trim() || sending}>
          {sending ? t("comment_form.sending") : t("comment_form.submit")}
        </button>
        <input
          type="text"
          placeholder={t("comment_form.placeholder")}
          value={text}
          onChange={(e) => setText(e.target.value)}
          style={styles.input}
          disabled={sending}
        />
      </form>

      {showSnackbar && (
        <div style={styles.snackbar} className="fade-in">
          {t("comment_form.sent")}
        </div>
      )}

      <style>{snackbarCSS}</style>
    </>
  );
};

const styles = {
  form: {
    display: "flex",
    flexDirection: "column", // 🔥 ahora los elementos se apilan
    gap: "8px",
    marginBottom: "10px",
    alignItems: "flex-start",
  },
  input: {
    width: "100%", // 🔥 ocupa todo el ancho disponible
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "0.95rem",
  },
  button: {
    alignSelf: "flex-end", // 🔥 botón alineado a la derecha encima del input
    padding: "6px 14px",
    borderRadius: "6px",
    border: "none",
    background: "#16A34A",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "transform 0.2s ease",
  },
  snackbar: {
    position: "fixed",
    bottom: "30px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "#2ecc71",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
    zIndex: 999,
    fontWeight: "bold",
  },
};

const snackbarCSS = `
  @keyframes fadeIn {
    0% { opacity: 0; transform: translateY(10px); }
    100% { opacity: 1; transform: translateY(0); }
  }

  .fade-in {
    animation: fadeIn 0.4s ease forwards;
  }
`;

export default CommentForm;
